import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=436db8cc&scoped=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=436db8cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436db8cc",
  null
  
)

export default component.exports